(function () {
  'use strict';

  var ENDPOINT = '/apps/pc/checkout-thumbnail';
  var ASSET_PROXY_URL = '/apps/pc/image-proxy';
  var uploadCache = new Map();

  function proxyUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.hostname.indexOf('wasabisys.com') !== -1) {
        return ASSET_PROXY_URL + '?maxSide=1024&url=' + encodeURIComponent(parsed.href);
      }
      return parsed.href;
    } catch (error) {
      return url;
    }
  }

  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      var image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = function () { resolve(image); };
      image.onerror = function () { reject(new Error('Nie udało się wczytać obrazu mockupu.')); };
      image.src = proxyUrl(url);
    });
  }

  function canvasBlob(canvas) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (blob) resolve(blob);
        else reject(new Error('Nie udało się wygenerować PNG mockupu.'));
      }, 'image/png', 0.92);
    });
  }

  function cacheKey(options) {
    return [options.type, options.baseUrl, options.designUrl].join('|');
  }

  function compose(options) {
    return Promise.all([loadImage(options.baseUrl), loadImage(options.designUrl)]).then(function (images) {
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      var size = 720;
      canvas.width = size;
      canvas.height = size;
      context.drawImage(images[0], 0, 0, size, size);

      var frame = options.type === 'drawstring'
        ? { x: 0.25, y: 0.24, width: 0.50, height: 0.56 }
        : options.type === 'bag'
        ? { x: 0.31, y: 0.43, width: 0.37, height: 0.38 }
        : options.type === 'pillow'
          ? { x: 0.25, y: 0.27, width: 0.48, height: 0.52 }
          : options.type === 'magic-mug'
            ? { x: 0.30, y: 0.34, width: 0.39, height: 0.43 }
          : options.type === 'mouse-pad'
            ? { x: 0.20, y: 0.32, width: 0.55, height: 0.44 }
          : { x: 0.25, y: 0.35, width: 0.43, height: 0.48 };
      context.globalAlpha = 0.94;
      context.globalCompositeOperation = 'multiply';
      context.drawImage(
        images[1],
        Math.round(size * frame.x),
        Math.round(size * frame.y),
        Math.round(size * frame.width),
        Math.round(size * frame.height)
      );
      context.globalCompositeOperation = 'source-over';
      context.globalAlpha = 1;
      return canvasBlob(canvas);
    });
  }

  function upload(blob) {
    var body = new FormData();
    body.append('image', blob, 'tortli-checkout-mockup.png');
    return fetch(ENDPOINT, {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok || !payload.url) throw new Error(payload.error || 'Nie udało się zapisać mockupu.');
        return payload.url;
      });
    });
  }

  function composeAndUpload(options) {
    if (!options || !options.baseUrl || !options.designUrl || (options.type !== 'mug' && options.type !== 'magic-mug' && options.type !== 'bag' && options.type !== 'drawstring' && options.type !== 'pillow' && options.type !== 'mouse-pad')) {
      return Promise.resolve('');
    }
    var key = cacheKey(options);
    if (!uploadCache.has(key)) {
      uploadCache.set(key, compose(options).then(upload).catch(function (error) {
        uploadCache.delete(key);
        console.warn('[Tortli] Nie udało się przygotować miniatury checkoutu.', error);
        return '';
      }));
    }
    return uploadCache.get(key);
  }

  window.TortliCheckoutThumbnail = { composeAndUpload: composeAndUpload };
})();
